import styled from 'styled-components';
import SvgArrowDown2 from '../../../../../others/svg_dist/ArrowDown2';
import SvgInfo from '../../../../../others/svg_dist/Info';

export const Wrapper = styled.div`
	width: 100%;
	&:not(:last-child) {
		margin-bottom: 45px;
	}
`;

export const MainContentContainer = styled.div`
	width: 100%;
	padding: 5px 10px;
	border: 2px solid #eaeaea;
	border-radius: 15px;
	background-color: #fff;
	.hover-popover {
		margin-bottom: -41px;
		transform: translate(15px, 15px);
		width: 35px;
	}
	@media screen and (max-width: 650px) {
		padding: 5px;
		position: relative;
		z-index: 9;
	}
`;

export const AdditionalContentContainer = styled.div`
	width: 95%;
	margin: 0 auto;
	background-image: linear-gradient(180deg, #f1f1f1, #e3e3e3);
	padding: 10px;
	border-radius: 0 0 10px 10px;
	@media screen and (max-width: 650px) {
		width: 100%;
		margin-top: -10px;
		padding: 10px 5px;
		padding-top: 20px;
	}
`;

export const HeadingContainer = styled.div`
	margin: 20px 0;
	width: 100%;
	p:nth-child(1) {
		margin: 0 auto;
		text-align: center;
		font-size: 18px;
		font-weight: 600;
	}
	p:nth-child(2) {
		margin: 0 auto;
		text-align: center;
		font-size: 14px;
		line-height: 1.3;
		color: #666666;
		span {
			color: #000;
		}
	}
`;

export const ButtonIconCotainer = styled.div<{ extended: boolean }>`
	background: ${({ extended }) => (extended ? '#0083c8' : '#313131')};
	height: 100%;
	width: 35px;
	position: absolute;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 0 12px 12px 0;
	svg {
		position: unset;
		top: 0;
		transform: ${({ extended }) => (extended ? 'rotate(180deg)' : 'unset')};
		right: 0;
		fill: #fff;
		width: 18px;
		height: 18px;
		transition: transform 150ms linear;
	}
`;

export const ButtonIcon = (props: { extended: boolean }) => (
	<ButtonIconCotainer extended={props.extended}>
		<SvgArrowDown2 />
	</ButtonIconCotainer>
);

export const getButtonStyle = (extended: boolean): React.CSSProperties => ({
	paddingLeft: '35px',
	width: '260px',
	whiteSpace: 'nowrap',
	fontSize: '14px',
	height: '35px',
	margin: 0,
	border: `2px solid ${extended ? '#0083c8' : '#313131'}`,
});

export const ButtonRail = styled.div<{ extended: boolean }>`
	width: 60px;
	height: 2px;
	background-color: ${({ extended }) => (extended ? '#0083c8' : '#ccc')};
`;

export const ButtonContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const ExtendedContentContainer = styled.div<{ extended: boolean }>`
	padding: ${({ extended }) => (extended ? '20px 5px 10px' : '0 5px')};
	transition: padding 75ms linear;
	overflow: hidden;
	height: ${({ extended }) => (extended ? 'auto' : '0')};
`;

export const ContentSocket = styled.div`
	margin-bottom: 20px;
	width: 100%;
`;

export const StyledSvgInfo = styled(SvgInfo)`
	width: 35px;
	height: 35px;
	fill: #d66464;
`;
